import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import ArrowRight from "../../components/icons/ArrowRight";
import routes from "../../utils/cftRoutes";

export default function BackToCoops() {
  const { t } = useTranslation(["cftChickenBroiler"]);
  const history = useHistory();

  return (
    <button
      style={{
        border: "none",
      }}
      type="button"
      onClick={() => {
        history.push(routes.CHICKEN_BROILER.COOPS);
      }}
    >
      <ArrowRight
        style={{
          transform: "rotate(180deg)",
          marginRight: "16px",
        }}
      />
      {t(
        "cftChickenBroiler:chickenBroilerCoopForm.back",
        "Kurniki referencyjne"
      )}
    </button>
  );
}
